export default {
  DEFAULT_PAGE_SIZE: 40,
  DEFAULT_SESSION_DURATION: 3600, // seconds
};
